export default "__VITE_ASSET__6c9ab2e5__"